import React, {useState, createContext, useEffect} from 'react';
import axios from "axios";
import {LocalServer} from './templates/WebIp';
import { Authentication } from './templates/authentication';
import { Dashboard } from './templates/dashboard';
export const AppContext = createContext();

function App() {
  var link = LocalServer();
  const [ accessToken, setAccessToken ] = useState();
  useEffect(()=>{
    if (accessToken!==undefined){
      getQuickReport();
    }
  },[accessToken]);
  const [ page, setPage ] = useState('home');
  const [ user, setUser ] = useState();
  const [ getExpiredLoad, setGetExpiredLoad ] = useState(false);
  const [ expired, setExpired ] = useState();
  const getExpired=()=>{
    setGetExpiredLoad(true);
    axios.get(`${link}api/ss/get/expired/accounts/`,{
          headers:{
            Authorization: 'Bearer '+accessToken
          }
        }).then((response)=>{
          setGetExpiredLoad(false);
          setExpired(response.data.values);
          setUser(prev=>({...prev,counts:response.data.counts}));
        }).catch((err)=>{
          setGetExpiredLoad(false);
          if(err.response.status === 401){
              setAccessToken();
          }else if(err.response.status === 404){
              console.log('Get_expired - ',err.response.status,':',err.response.statusText);
          }else if(err.response.status === 500){
              console.log('Get_expired - ',err.response.status,':',err.response.statusText);
          }else{
              console.log('Get_expired - ',err.response.status,':',err.response.data);
          }
    });
  }
  const [ staff, setStaff ] = useState();
  const [ getStaffLoad, setGetStaffLoad ] = useState(false);
  const getStaffs=()=>{
    setGetStaffLoad(true);
    axios.get(`${link}api/ss/get/staffs/`,{
          headers:{
            Authorization: 'Bearer '+accessToken
          }
        }).then((response)=>{
          setGetStaffLoad(false);
          setStaff(response.data);
        }).catch((err)=>{
          setGetStaffLoad(false);
          if(err.response.status === 401){
              setAccessToken();
          }else if(err.response.status === 404){
              console.log('Get_staffs - ',err.response.status,':',err.response.statusText);
          }else if(err.response.status === 500){
              console.log('Get_staffs - ',err.response.status,':',err.response.statusText);
          }else{
              console.log('Get_staffs - ',err.response.status,':',err.response.data);
          }
    });
  }
  const [ getQuickLinksLoad, setGetQuickLinksLoad ] = useState(false);
  const [ quickLinks, setQuickLinks ] = useState();
  const getQuickLinks=()=>{
    setGetQuickLinksLoad(true);
    axios.get(`${link}api/ss/get/quick/link/`,{
          headers:{
            Authorization: 'Bearer '+accessToken
          }
        }).then((response)=>{
          setGetQuickLinksLoad(false);
          setQuickLinks(response.data);
        }).catch((err)=>{
          setGetQuickLinksLoad(false);
          if(err.response.status === 401){
              setAccessToken();
          }else if(err.response.status === 404){
              console.log('Get_Quick_links - ',err.response.status,':',err.response.statusText);
          }else if(err.response.status === 500){
              console.log('Get_Quick_links - ',err.response.status,':',err.response.statusText);
          }else{
              console.log('Get_Quick_links - ',err.response.status,':',err.response.data);
          }
    });
  }
  const [ quickReport, setQuickReport ] = useState();
  const [ getQuickLoad, setGetQuickLoad ] = useState(false);
  const getQuickReport=()=>{
    setGetQuickLoad(true);
    axios.get(`${link}api/ss/get/quick/report/`,{
          headers:{
            Authorization: 'Bearer '+accessToken
          }
        }).then((response)=>{
          setGetQuickLoad(false);
          setQuickReport(response.data);
        }).catch((err)=>{
          setGetQuickLoad(false);
          if(err.response.status === 401){
              setAccessToken();
          }else if(err.response.status === 404){
              console.log('Get_Quick_links - ',err.response.status,':',err.response.statusText);
          }else if(err.response.status === 500){
              console.log('Get_Quick_links - ',err.response.status,':',err.response.statusText);
          }else{
              console.log('Get_Quick_links - ',err.response.status,':',err.response.data);
          }
    });
  }
  const [ enquiry, setEnquiry ] = useState();
  const [ getEnquiryLoad, setGetEnquiryLoad ] = useState(false);
  const getEnquiry=()=>{
    setGetEnquiryLoad(true);
    axios.get(`${link}api/ss/get/customer/request/`,{
          headers:{
            Authorization: 'Bearer '+accessToken
          }
        }).then((response)=>{
          setGetEnquiryLoad(false);
          setEnquiry(response.data);
        }).catch((err)=>{
          setGetEnquiryLoad(false);
          if(err.response.status === 401){
              setAccessToken();
          }else if(err.response.status === 404){
              console.log('Get_Enquiry - ',err.response.status,':',err.response.statusText);
          }else if(err.response.status === 500){
              console.log('Get_Enquiry - ',err.response.status,':',err.response.statusText);
          }else{
              console.log('Get_Enquiry - ',err.response.status,':',err.response.data);
          }
    });
  }
  return (
    <AppContext.Provider value={{ accessToken, link, setPage, page, setAccessToken, user, setUser, getExpired, setExpired,
    getExpiredLoad, setGetExpiredLoad, expired, getStaffs, staff, setStaff, getStaffLoad,  getQuickLinksLoad, getQuickLinks,
    quickLinks, setQuickLinks, quickReport, getQuickLoad, getQuickReport, enquiry, getEnquiryLoad, getEnquiry, setEnquiry }} >    
    {
      accessToken===undefined?(
        <Authentication />
        ):(
        <Dashboard />
        )
    }
    </AppContext.Provider>
  );
}

export default App;
